import { downloadSteps } from '@/mocks/home';

export default function DownloadGuide() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            po18官网app下载步骤
          </h2>
          <p className="mt-4 text-foreground-600 text-base max-w-2xl mx-auto">
            四步轻松完成下载安装，开启您的阅读之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {downloadSteps.map((step) => (
            <div key={step.step} className="relative text-center group">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl font-bold mb-5 group-hover:bg-primary-600 transition-colors duration-300">
                {step.step}
              </div>
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${step.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
          >
            <i className="ri-android-line text-lg"></i>
            安卓版下载
          </a>
          <a
            href="#"
            className="whitespace-nowrap cursor-pointer bg-foreground-900 text-background-50 px-8 py-3.5 rounded-full text-base font-medium hover:bg-foreground-950 transition-all duration-300 transform hover:scale-105 flex items-center gap-2"
          >
            <i className="ri-apple-line text-lg"></i>
            苹果版下载
          </a>
        </div>
      </div>
    </section>
  );
}